/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState, useRef} from "react";
import "./DashboardHeader.scss";
import ArrowLink from "../../common/ArrowLink/ArrowLink";
import {useDispatch, useSelector} from "react-redux";
import "./DashboardAdminHeader.scss";
import {useTranslation} from "react-i18next";
import moment from "moment";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import {hideLoading, showLoading} from "../../../reducers/app";
import {client} from "../../../App";
import {DOWNLOAD_BILLS} from "../../../helpers/queries";
import {payBills, checkConractStatus} from "../../../helpers/helpers";
import {Link, useHistory} from "react-router-dom";
import CardImage from "./assets/card-link.png";

const DashboardAdminHeader = (props) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const [lsbills, setLsBills] = useState([]);
  const [unpaidBill, setUnpaidBills] = useState([]);
  const [lastBill, setLastBills] = useState([]);
  const [amountConsume, setAmountConsume] = useState(0);

  // eslint-disable-next-line
  const [genericError, setGenericError] = useState(null);
  const clientId = useSelector((state) => state.contracts.current);
  const usages = useSelector((state) => state.contracts.usages);
  const bills = useSelector((state) => state.contracts.bills);

  const convertTime = (time) => {
    return moment(time).format("DD/MM/YYYY");
  };

  const isMountedRef = useRef(false);
  const isMountedRef2 = useRef(false);
  const isMountedRef3 = useRef(false);
  const isMountedRef4 = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    let arrayBills = [];
    if (bills.length > 0) {
      let lastBills = bills.slice(0, 3);
      lastBills.map((bill) => {
        let paied = bill.isPaid
          ? t("dashboard.admin.header.payed")
          : t("dashboard.admin.header.unpayed");
        let amount = "€ " + bill.paidAmount;
        return arrayBills.push({
          bill: {
            part1: [
              {
                title: t("dashboard.admin.header.client.code"),
                description: clientId.clientId,
              },
              {title: t("dashboard.admin.header.bill"), description: paied, isPaid : bill.isPaid},
            ],
            part2: [
              {
                title: t("dashboard.admin.header.date"),
                description: convertTime(bill.issueDate),
              },
              {
                title: t("dashboard.admin.header.amount"),
                description: amount,
              },
            ],
          },
        });
      });
      if (isMountedRef.current) {
        setLsBills(arrayBills);
      }
    }
    return () => {
      // Called before unmount by React
      isMountedRef.current = false;
    };
  }, [bills, clientId, t]);

  useEffect(() => {
    isMountedRef2.current = true;
    if (bills && bills.length) {
      const bill = bills.find(billStatus);
      if (bill) {
        const consumption = usages.filter(
          (usage) => usage.invoiceNumber === bill.invoiceNumber
        );
        if (isMountedRef2.current) {
          setAmountConsume(consumption[0]?.consumption);
        }
      }
    }
    return () => {
      // Called before unmount by React
      isMountedRef2.current = false;
    };
  }, [bills, usages]);

  useEffect(() => {
    isMountedRef3.current = true;
    if (bills && bills.length > 0) {
      let bill = bills.find(billStatus);
      if (bill) {
        if (isMountedRef3.current) {
          setUnpaidBills([bill]);
        }
      }
    }
    return () => {
      // Called before unmount by React
      isMountedRef2.current = false;
    };
  }, [bills, t]);

  useEffect(() => {
    isMountedRef4.current = true;
    if (bills && bills.length > 0) {
      let bill = bills.find(lastBillStatus);
      if (bill) {
        if (isMountedRef4.current) {
          setLastBills([bill]);
        }
      }
    }
    return () => {
      // Called before unmount by React
      isMountedRef2.current = false;
    };
  }, [bills, t]);

  const billStatus = (element) => {
    if (!element.isPaid) return element;
  };

  const lastBillStatus = (element) => {
    if (element.isPaid) return element;
  };

  const handleDownload = async (bill) => {
    const billCode = bill.invoiceNumber;
    const contractCode = clientId.id;

    dispatch(showLoading());
    try {
      const downloadBills = await client().query({
        query: DOWNLOAD_BILLS,
        variables: {
          req: {
            contractId: contractCode,
            invoiceNumbers: [billCode],
            downloadType: "ZIP",
          },
        },
        fetchPolicy: "network-only",
      });
      if (
        downloadBills.data &&
        downloadBills.data.invoicesDownload &&
        downloadBills.data.invoicesDownload.path
      ) {
        window.open(downloadBills.data.invoicesDownload.path, "_blank");
        dispatch(hideLoading());
      }
    } catch (error) {
      console.log(error);
      dispatch(hideLoading());
    }
  };

  const handlePayBill = (bill) => {
    const billCode = bill.id;
    const currentContract = clientId.id;

    const billsToPaid = {
      codIdContratto: currentContract,
      codIdBolletta: billCode,
      channel: "WEB",
    };
    payBills(billsToPaid, dispatch, setGenericError, [bill]);
  };

  const cases = [
    {
      title: t("listcasepage.case.li.verifica_della_pressione"),
      description: t("common.discover"),
      route: "verifica-della-pressione",
    },
    {
      title: t("listCasePage.case.li.verifica_contatore"),
      description: t("common.discover"),
      route: "verifica-contatore",
    },
    {
      title: t("listCasePage.case.li.preventivo_lavori"),
      description: t("common.discover"),
      route: "preventivo-lavori",
    },
  ];

  const slides = [
    /* unpaid bill slide */
    ( unpaidBill &&
      unpaidBill.length > 0) ? (
        <div
          key={0}
          className="items-container" role="list"
          style={{position: "relative"}}
        >
          <div className="item-holder" role="listitem">
            <h2 className="item-header">
                {t("dashboard.admin.last.bill")}
            </h2>

            <div className="item-text">
              <p>
                {t("dashboard.admin.header.billNumber")}{" "}
                {unpaidBill[0].invoiceNumber}
              </p>
              <p>
                {t("dashboard.admin.header.billOf")}{" "}
                {convertTime(unpaidBill[0].issueDate)}
              </p>
            </div>

            <div className="item-element-text">
              <p className="item-label">{t("dashboard.admin.header.consume")}</p>
              <p className="item-content">
                {t("dashboard.upaid.bills.text.part1")}{" "}
                {amountConsume}
                {" m3. "}
                {t("dashboard.upaid.bills.text.part2")}
              </p>
            </div>

            <div className="item-element-text">
              <p className="item-label">{t("dashboard.admin.header.clientCode")}</p>
              <p className="item-content">{clientId.clientId}</p>
            </div>

            <div className="item-element-text price">
              <p className="item-label">{t("dashboard.admin.header.pay")}</p>
              <p className="item-content">{"€ " + unpaidBill[0].amount}</p>
            </div>
          </div>

          <div className={"button"}>
            <button 
              type="button"
              className="btn btn-secondary"
              onClick={() => handleDownload(unpaidBill[0])}
            >
              {t("common.download")}
            </button>

            <button 
              type="button"
              className="btn btn-primary"
              onClick={() => handlePayBill(unpaidBill[0])}
            >
              {t("common.payment")}
            </button>
          </div>
        </div>
      ) : null,
    /* last bill slide */
    lastBill.length > 0 ? (
      <div
        key={0}
        className="items-container" role="list"
        style={{position: "relative"}}
      >
        <div className="item-holder" role="listitem"> 
          <h2 className="item-header">
              {t("dashboard.admin.last.pay")}
          </h2>

          <div className="item-text">
            <p>
              {t("dashboard.admin.header.billNumber")}{" "}
              {lastBill[0].invoiceNumber}
            </p>
            <p>
              {t("dashboard.admin.header.billOf")}{" "}
              {convertTime(lastBill[0].issueDate)}
            </p>
          </div>

          <div className="item-element-text">
            <p className="item-label">{t("dashboard.admin.header.consume")}</p>
            <p className="item-content">
              {t("dashboard.admin.pay.text")}
            </p>
          </div>

          <div className="item-element-text">
            <p className="item-label">{t("dashboard.admin.header.clientCode")}</p>
            <p className="item-content">{clientId.clientId}</p>
          </div>

          <div className="item-element-text price">
            <p className="item-label">{t("dashboard.admin.header.pay")}</p>
            <p className="item-content">{"€ " + lastBill[0].amount}</p>
          </div>
        </div>

        <div className="button">
          <button 
            type="button"
            className="btn btn-secondary"
            onClick={() =>
              history.push({pathname: "/bills"})
            }
          >
            {t(
              "dashboard.admin.header.btnBills"
            )}
          </button>
          <button 
            type="button"
            className="btn btn-primary"
            onClick={() => handleDownload(lastBill[0])}
          >
            {t("common.download")}
          </button>
        </div>
      </div>
    ) : null
  ].filter(Boolean);
  const carouselRef = useRef(null);
  const [isPrevDisabled, setIsPrevDisabled] = useState(true)
  const goPrev = () => carouselRef.current?.slidePrev();
  const goNext = () => carouselRef.current?.slideNext();

    return (
      <section className="DashboardAdminHeader" data-testid="DashboardAdminHeader" role="region" aria-labelledby="last-bills-last-payment-header">
        {lsbills.length > 0 ? (
          <div className="container">
            <div className="row mt-4">
              {/* firs box */}
              {lsbills.length > 0 ? (
                <div className="col-sm-12 col-md-6 last-bills-container">
                  <div className="item item--with-background">
                    <div className="item-inner-container">
                      <div className="item-header">
                        <h2 className="headline-bold-fs4" id="last-bills-last-payment-header">
                          {t("dashboard.admin.last.bills")}
                        </h2>
                        <ArrowLink className="gcap-cta" to={"/bills/view-all"}
                          aria-label={t("dashboard.admin.bills.view.all") + " " + t("dashboard.admin.last.bills")}>
                            {t("dashboard.admin.bills.view.all")}
                        </ArrowLink>
                      </div>
                      <div className="content-container" role="list">
                        {lsbills.length > 0 &&
                          lsbills.map((boxElement, key) => {
                            return (
                              <div className="items" key={key} role="listitem">
                                <div className="box-item">
                                <div className="inner-box-container">
                                  {boxElement.bill.part1.map(
                                    (singleElement, key) => {
                                      const descriptionClass = key === 1 ? 'capitalize' : '';
                                      const circleClass = singleElement.isPaid ? 'circle-green' : 'circle-red';
                                      return (
                                        <div
                                          className="box-inside-item p1"
                                          key={key}
                                        >
                                          <p className="paragraph-main-fs8">{singleElement.title}</p>
                                          <p className="paragraph-large-fs7">
                                            {key === 1 && (
                                              <span className={`status-circle ${circleClass}`} aria-hidden="true"></span>
                                            )}
                                            <span className={`description paragraph-large-fs7 ${descriptionClass}`}>{singleElement.description}</span>
                                          </p>
                                        </div>
                                      );
                                    }
                                  )}
                                </div>

                                  <div className="inner-box-container">
                                    {boxElement.bill.part2.map(
                                      (singleElement, key) => {
                                        return (
                                          <div
                                            className="box-inside-item p2"
                                            key={key}
                                          >
                                            <p className="paragraph-main-fs8">{singleElement.title}</p>
                                            <p className="paragraph-large-fs7">
                                              {singleElement.description}
                                            </p>
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                </div>
                                <hr className="line"/>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              {/* second box */}
              {unpaidBill.length > 0 || lastBill.length > 0 ? (
                <div className="col-sm-12 col-md-6 last-payments">
                  <div className="item item--with-background">
                    <div className="item-inner-container">
                      {unpaidBill.length > 0 && lastBill.length > 0 ? (
                      <div className="alice-carousel-controls">
                        <button 
                            type="button"
                            id="alice-carousel-back-btn"
                            className="alice-carousel__arrows prev gc-icon-functional-arrow-back" 
                            aria-label={t("cases.buttons.back")}
                            onClick={goPrev}
                            disabled={isPrevDisabled}
                            aria-hidden={isPrevDisabled}>
                          </button>
                          <button
                            type="button"
                            id="alice-carousel-next-btn"
                            className="alice-carousel__arrows next gc-icon-functional-arrow-right"
                            aria-label={t("cases.buttons.proceed")}
                            onClick={goNext}
                            disabled={!isPrevDisabled}
                            aria-hidden={!isPrevDisabled}>
                          </button>
                      </div>
                      ) : null}
                      <AliceCarousel
                        ref={carouselRef}
                        activeIndex={(checkConractStatus(clientId.state) && unpaidBill.length) > 0 ? 0 : 1}
                        animationType={"fadeout"}
                        animationDuration={200}
                        disableDotsControls
                        disableButtonsControls
                        items={slides}
                        onSlideChanged={(e) => {setIsPrevDisabled(e.isPrevSlideDisabled)}}>
                      </AliceCarousel>
                    </div>
                  </div>
                </div>
            ) : null}
            <section className="link-grid-external-new bg-white">
              <div className="link-grid-external__content d-flex ">
                  <h2 className="link-grid-external__content--title headline-bold-fs4">
                    {t("dashboard.admin.header.box3")}
                  </h2>
                  <div className="link-grid-external__content--description headline-fs5">
                    <ArrowLink to={"/view-cases"} className="gcap-cta">
                      {t("common.view.all")}
                    </ArrowLink>
                  </div>
                </div>
                <div className="link-grid-external__cta">
                  {cases.map((element, key) => {
                    return (
                      <Link
                        key={key}
                        style={{position: "relative"}}
                        to={`/${element.route}`}
                        className="link-grid-external__cta-holder bg-grey-4"
                      >
                        <div className="img-container d-sm-block">
                          <img src={CardImage} className="link-grid-external__image"/>
                        </div>
                        <span className="headline-fs5">{element.title}</span>
                        <i className="gc-icon-functional-arrow-right" aria-hidden="true"></i>
                      </Link>
                    );
                  })}
                </div>
            </section>
            </div>
          </div>
        ) : null}
      </section>
    );
  };

export default DashboardAdminHeader;
